import { Outlet } from 'react-router-dom'
import { Flex, Layout } from 'antd'
import { Footer, Header } from 'shared/components'

interface PageProps {}

const Page: FC<PageProps> = () => {
  const { Content } = Layout

  return (
    <Flex vertical justify='space-between' style={{ minHeight: '100vh' }}>
      <Header />
      <Content>
        <Outlet />
      </Content>
      <Footer />
    </Flex>
  )
}

export default Page
